import styled from 'styled-components'
import { Trans } from 'react-i18next'
import config from '@/config'
import { Box } from '@/components/structure'

const { WEB_URL } = config

const Link = styled.a`
  display: inline;
  color: inherit;
  text-decoration: underline;
`

export const alertOneTime = t => {
  return {
    body: (
      <Trans t={t} i18nKey="l.payments.view.request_payment_modal.alert_one_time_body">
        Based on the payment method and deposit account, the fees charged for each payout may
        differ. Check our{' '}
        <Link href={`${WEB_URL}/faq`} target="_blank" rel="noopener noreferrer">
          FAQ
        </Link>{' '}
        for the latest fee amounts as this may be subject to change without notice.
      </Trans>
    ),
    icon: 'alert_info',
    theme: 'info',
    space: 'fit',
    isShow: true
  }
}

export const alertPadDisabled = t => {
  return {
    title: t(
      'l.payments.view.request_payment_modal.alert_pad_disabled_title',
      'You must have PAD authorized to continue.'
    ),
    body: (
      <Trans t={t} i18nKey="l.payments.view.request_payment_modal.alert_pad_disabled_body">
        <div>
          Please authorize PAD through payment settings or select a different payment method. Once
          complete, please refresh this page and try again.
        </div>
        <Box top={'8px'}>
          <a href="/settings/payment-settings" target="_blank">
            Payment Settings
          </a>
        </Box>
      </Trans>
    ),
    icon: 'alert_error',
    theme: 'error',
    isShow: true
  }
}

export const alertPadActive = t => {
  return {
    body: (
      <Trans t={t} i18nKey="l.payments.view.request_payment_modal.alert_pad_active_body">
        Recurring PAD payments are already active in this listing. Please select a different Payment
        type to continue.
      </Trans>
    ),
    icon: 'alert_error',
    theme: 'error',
    isShow: true
  }
}

export const alertPadRequested = t => {
  return {
    body: (
      <Trans t={t} i18nKey="l.payments.view.request_payment_modal.alert_pad_pending_body">
        You have a pending PAD request for this listing. Please select a different payment type to
        continue.
      </Trans>
    ),
    icon: 'alert_error',
    theme: 'error',
    isShow: true
  }
}
